import { render, staticRenderFns } from "./CoveredLegislations.vue?vue&type=template&id=3ef6d496&scoped=true&"
import script from "./CoveredLegislations.vue?vue&type=script&lang=js&"
export * from "./CoveredLegislations.vue?vue&type=script&lang=js&"
import style0 from "./CoveredLegislations.vue?vue&type=style&index=0&id=3ef6d496&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef6d496",
  null
  
)

export default component.exports